import { useMemo } from "react";

import { getDataSourceStore } from "src/utils/devextreme-grid";
import api, { useSWR } from "../utils/axios";

import { HOST_API } from "../config-global";

export const endpoint = "locations";

const baseUrl = `/api/${endpoint}/`;

export function getGrid(typeId) {
  return getDataSourceStore(`${HOST_API}${baseUrl}get-grid/${typeId}`);
}

export function remove(id) {
  return api.delete(`${baseUrl}${id}`);
}

export function restore(id) {
  return api.put(`${baseUrl}${id}`);
}

export function useGetPlainTree(shouldFetch = true) {
  const url = `${baseUrl}plain-tree`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(shouldFetch ? url : null);

  const memoizedValue = useMemo(
    () => ({
      tree: data || [],
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

export function create(data) {
  return api.post(`${baseUrl}`, data);
}

export function update(id, data) {
  return api.put(`${baseUrl}update/${id}`, { ...data });
}

export function getById(id) {
  return api.get(`${baseUrl}${id}`);
}

export function getUndelete(id) {
  return api.get(`${baseUrl}get-undelete/${id}`);
}

export function useGetLocation(id) {
  const url = `${baseUrl}${id}`;

  const { data, isLoading, error, isValidating, mutate } = useSWR(id ? url : null);

  const memoizedValue = useMemo(
    () => ({
      asset: data ? { ...data } : null,
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}
